import { render, staticRenderFns } from "./auth-reset.vue?vue&type=template&id=466b7e52&scoped=true"
import script from "./auth-reset.vue?vue&type=script&lang=js"
export * from "./auth-reset.vue?vue&type=script&lang=js"
import style0 from "./auth-reset.vue?vue&type=style&index=0&id=466b7e52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b7e52",
  null
  
)

export default component.exports